import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { useOrderingEnabled } from '../../hooks/useOrderingEnabled';

/**
 * Shows the admin-configured message when online ordering is globally disabled.
 * Renders nothing while ordering is enabled.
 */
const OrderingDisabledBanner = ({ className = '' }) => {
  const { enabled, message } = useOrderingEnabled();

  if (enabled) return null;

  return (
    <div
      role="alert"
      className={`flex items-start gap-3 rounded-lg border border-[#fed402] bg-yellow-50 p-4 text-[#1a1818] ${className}`}
    >
      <AlertTriangle className="h-5 w-5 flex-shrink-0 text-yellow-600 mt-0.5" />
      <div>
        <p className="font-semibold">Online ordering is currently unavailable</p>
        <p className="text-sm mt-1 whitespace-pre-line">{message}</p>
      </div>
    </div>
  );
};

export default OrderingDisabledBanner;
